import { useState } from 'react'
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar'
import CrossIcon from '@/CustomIcons/CrossIcon'
import 'react-circular-progressbar/dist/styles.css'

const containerClass =
    'relative w-[42px] h-[42px] items-center justify-center ' +
    'cursor-pointer transparent border-muse-toplit hover:bg-white/5 rounded-full ' +
    'transition-all duration-50 ease-in-out'

export default function CircularProgressWithLabel({ value, onClick }: { value: number; onClick?: () => void }) {
    const [isHovering, setIsHovering] = useState(false)

    return (
        <div
            className={containerClass}
            onClick={onClick}
            onMouseEnter={() => onClick && setIsHovering(true)}
            onMouseLeave={() => onClick && setIsHovering(false)}
        >
            <div className="absolute top-[-1px] left-[-1px] w-[43px] h-[43px]">
                <CircularProgressbar
                    value={value}
                    strokeWidth={3}
                    styles={buildStyles({
                        pathColor: '#f9cc04',
                        textColor: '#f9cc04',
                        trailColor: 'transparent',
                        textSize: '26px',
                    })}
                />
                <div className="absolute flex top-0 left-0 w-[42px] h-[42px] items-center justify-center text-muse-yellow text-[11px]">
                    <div
                        className={`transition-opacity duration-50 ease-in-out ${isHovering ? 'opacity-0' : 'opacity-100'}`}
                    >
                        {`${value}%`}
                    </div>
                    <div
                        className={`absolute transition-opacity duration-50 ease-in-out ${isHovering ? 'opacity-100' : 'opacity-0'}`}
                    >
                        <CrossIcon />
                    </div>
                </div>
            </div>
        </div>
    )
}
